
































































import Vue, { PropOptions } from 'vue';
import moment from 'moment';
import { round } from 'lodash';

interface Props {
  value: PropOptions;
  inputName: PropOptions;
  title: PropOptions;
  uploadButtonText: PropOptions;
  changeButtonText: PropOptions;
  imagePositionP: PropOptions;
}

interface LocalState {
  photo: PhotoResponse | null;
  imagePosition: string;
}

export default Vue.extend({
  name: 'ProductSalesPageUploader',
  data(): LocalState {
    return {
      photo: null,
      imagePosition: 'left',
    };
  },
  props: {
    value: {
      type: [Object as () => PhotoResponse],
    },
    inputName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    uploadButtonText: {
      type: String,
      required: true,
    },
    changeButtonText: {
      type: String,
      required: true,
    },
    imagePositionP: {
      type: String,
      required: false,
    },
  } as Props,
  mounted() {
    this.photo = this.value;
    this.imagePosition = this.imagePositionP;
  },
  computed: {
    fileSize(): string {
      if (this.value) {
        const size = round(this.value.file_size / 1048576, 1);
        return `${size} MB`;
      }
      return '';
    },
    date(): string {
      if (this.value) return moment(this.value.uploaded).format('lll');
      return '';
    },
  },
  watch: {
    photo: {
      handler(value: PhotoResponse) {
        this.$emit('input', value);
      },
    },
    imagePosition: {
      handler(value: string) {
        this.$emit('updateImagePosition', value);
      },
    },
  },
  methods: {
    remove(): void {
      this.photo = null;
    },
  },
});
